import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';

ReactDOM.render(
    <React.StrictMode>
        <title>Domain Search</title>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);